import SurveyTemplateForm from "./survey_template/SurveyTemplateForm";
import SurveyTemplate from "./survey_template/SurveyTemplate";
import SurveyUserForm from './survey_user_form/SurveyUserForm';
import SurveyComplete from './survey_user_form/SurveyComplete';
import SurveyResult from "./survey_result/SurveyResult";

const SurveyRouter = [{
  type: 'private',
  path: '/encuestas/crear',
  roles: ['administrador'],
  component: SurveyTemplateForm,
  exact: true
},{
  type: 'private',
  path: '/encuestas',
  roles: ['administrador'],
  component: SurveyTemplate,
  exact: true
},{
  type: 'private',
  path: '/encuestas/:id/update',
  roles: ['administrador'],
  component: SurveyTemplateForm,
  exact: true
},{
  type: 'private',
  path: '/encuestas/:id/formulario',
  roles: ['administrador'],
  component: SurveyUserForm,
  exact: true
},{
  type: 'private',
  path: '/encuestas/:id/resultados',
  roles: ['administrador'],
  component: SurveyResult,
  exact: true
},{
  type: 'private',
  path: '/encuestas/complete',
  roles: ['administrador'],
  component: SurveyComplete,
  exact: true
}];

export default SurveyRouter;